/**
 *
 * @description 转换props的areaId 或 面板已选的树节点。满足出入参
 * @export
 * @param {*} areaItem
 * @param {boolean} [isTransform=true]
 * @return {*}
 */
export function formatterAreadResult (areaItem, isTransform = true) {
  if (!areaItem) {
    return null
  }
  const { areaId, areaName, districtID, districtName, zoneCode } = areaItem
  return isTransform ? { districtID: areaId, districtName: areaName } : { areaId: districtID, areaName: districtName, areaCode: zoneCode }
}

/**
 *
 * @description 判断当前层级与限制层级（用户配置的）是否相等
 * @export
 * @param {*} currentLevel
 * @param {*} limitLevel
 * @param {*} type
 * @return {*}
 */
export function isPreventDownOnLevel (currentLevel, limitLevel, type) {
  switch (type) {
    case 'equal':
      return +currentLevel === +limitLevel
    case 'greater':
      return +currentLevel > +limitLevel
    case 'greaterEqual':
      return +currentLevel >= +limitLevel
    default:
    return +currentLevel < +limitLevel
  }
}

export function isEqualDistricID (selected, cityProps) {
  const val = selected && cityProps && cityProps.item && selected.districtID === cityProps.item.districtID
  return val
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/utils/tools.js